module.exports = __webpack_public_path__ + "img/bnaWallet.39539fcf.png";